import BreadCrumb from "Common/BreadCrumb";
import FileInput from "Common/fileInput";

import useSettings from "hooks/useSettings";

import { useMutation, useQueryClient } from "react-query";
import { ToastContainer, toast } from "react-toastify";
import { setLogo } from "services/settings.service";
import { IFile } from "types/file.type";

export default function Settings() {
  const { data, isLoading, refetch } = useSettings();
  const queryClient = useQueryClient();

  const { isLoading: adding, mutate } = useMutation(
    async (input: IFile) => await setLogo(input),
    {
      onSuccess(data) {
        toast.success(data?.message);
        queryClient.invalidateQueries("settings");
        refetch();
      },
      onError(error: any) {
        toast.error(error?.response?.data?.message);
      },
    }
  );

  const handleLogoUpload = (file: IFile) => {
    mutate(file);
  };
  return (
    <main className=" flex flex-col gap-4">
      <ToastContainer />
      <div>
        <BreadCrumb title="Settings" pageTitle="Settings" />
      </div>

      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <div className="bg-white rounded-lg border border-gray-200 flex flex-col gap-4 p-6 w-full lg:max-w-[60%]">
          {data?.data?.logo && (
            <img
              src={data?.data?.logo.url}
              alt=""
              className=" h-16 w-16 mx-auto "
            />
          )}

          <FileInput
            label={data?.data?.logo ? "Change logo" : "Upload logo"}
            file={data?.data?.logo!}
            onUpload={handleLogoUpload}
          />

          {adding && <span className=" my-6">Uploading...</span>}
        </div>
      )}
    </main>
  );
}
